module.exports = __webpack_public_path__ + "img/promo_banner.9d436ee1.png";